import React from 'react'
import { LicensePlate } from '../../types'

type VehicleDetailsProps = {
  vehicleInfo: LicensePlate
}

const VehicleDetails: React.FC<VehicleDetailsProps> = (props) => {
  const {
    vehicleInfo,
  } = props;

  return (
    <div>
      <div className="flex">
          <div>
            <div className="flex items-center gap-4">
              {vehicleInfo.logo_marque && (
                <img
                  src={vehicleInfo.logo_marque}
                  alt={`Logo ${vehicleInfo.marque}`}
                  className="max-h-16 object-contain"
                  onError={(e) => {
                    e.currentTarget.style.display = 'none'
                  }}
                />
              )}
              <div className="flex flex-col gap-1">
                <div className="flex-grow-0">
                  <span>{vehicleInfo.marque}</span>
                  &nbsp;
                  <span>{vehicleInfo.modele}</span>
                </div>
                {/* <div className="flex-grow-0 font-bold text-sm">
                  {vehicleInfo.sra_commercial}
                </div> */}
              </div>
            </div>
          </div>
        {vehicleInfo.photo_modele && (
          <div className="ml-auto">
            <img
              src={vehicleInfo.photo_modele}
              alt={`${vehicleInfo.marque} ${vehicleInfo.modele}`}
              className="w-24 max-h-48 lg:w-48 object-contain rounded-lg border border-gray-200"
              onError={(e) => {
                e.currentTarget.style.display = 'none'
              }}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default VehicleDetails;